module.exports = __webpack_public_path__ + "img/address-bo.6eb0fd75.svg";